
export let globalBuildContext;

export function _setGlobalBuildContextForLegacySupport (buildContext) {
  globalBuildContext = buildContext;
}



// WEBPACK FOOTER //
// ./lib/rlink-router/__globalBuildContextForLegacySupport__.js